export default "__VITE_ASSET__DZYZTVat__"